<div class="client-view" data-testid="client-view">
  <div class="client-view__container" data-testid="route-client-wheel">
    <!-- Coach branding header (if available) -->
    <div class="client-view__header" [style.background]="getHeaderGradient()">
      @if (clientData?.coach?.brand?.logoUrl) {
        <img
          [src]="clientData!.coach.brand!.logoUrl"
          [alt]="'Coach logo'"
          class="client-view__logo"
          data-testid="coach-logo"
          />
      }
      <div>
        @if (clientData?.client?.name) {
          <p class="client-view__welcome">Welcome, {{ clientData!.client.name }}</p>
        }
        <p class="client-view__instruction">{{ clientData?.wheel?.name || "" }}</p>
      </div>
    </div>

    <!-- Partial Data Error Banner -->
    @if (hasDataError) {
      <div class="client-view__error-banner" data-testid="partial-data-error">
        <div class="client-view__error-icon">⚠️</div>
        <div class="client-view__error-content">
          <h3 class="client-view__error-title">Assessment Data Issue</h3>
          <p class="client-view__error-message">{{ errorMessage }}</p>
        </div>
      </div>
    }

    <!-- Wheel component with client mode enabled -->
    <!-- Only show if no data errors -->
    @if (!hasDataError) {
      <div>
        <wil-wheel
          type="professional"
          [wheelId]="wheelId"
          [showCategories]="true"
          [clientId]="clientData?.client?.id || null"
          [coachId]="clientData?.coach?.id || null"
          data-testid="client-wheel"
          />
        </div>
      }

      <!-- Limited UI when data errors exist -->
      @if (hasDataError) {
        <div class="client-view__limited-mode" data-testid="limited-mode">
          <p class="client-view__limited-message">
            The assessment cannot be completed due to missing data. Please contact your coach for assistance.
          </p>
        </div>
      }
    </div>
  </div>
